import * as tslib_1 from "tslib";
import Vue from "vue";
import { Component } from "vue-property-decorator";
let FileExporer2View = class FileExporer2View extends Vue {
    constructor() {
        super();
        this.fileIcons = {
            html: "mdi-language-html5",
            js: "mdi-nodejs",
            json: "mdi-json",
            md: "mdi-markdown",
            pdf: "fas fa-file-pdf",
            png: "mdi-file-image",
            txt: "mdi-file-document-outline",
            xls: "fas fa-file-excel",
            xlsx: "fas fa-file-excel",
            docx: "fas fa-file-word",
            doc: "fas fa-file-word"
        };
        this.breadCrumbs = [];
        this.selectedRows = [];
        this.headers = [
            {
                text: "Title",
                align: "start",
                sortable: false,
                value: "title"
            },
            { text: "Filename", value: "name" },
            { text: "Permissions", value: "permissions" },
            { text: "Modified On", value: "lastModifiedOn" },
            { text: "Modified By", value: "lastModifiedBy" },
            { text: "Size", value: "size" }
        ];
        this.rootFolder = {
            title: "Aileron",
            name: "aileron",
            type: "folder",
            roles: ["staff"],
            items: [
                {
                    title: "Course For Presidents",
                    name: "aileron/cfp",
                    type: "folder",
                    roles: ["cfp"],
                    items: []
                },
                {
                    title: "Concious Leadership",
                    name: "aileron/concious_leadership",
                    type: "folder",
                    roles: ["concious-leadership"],
                    items: []
                },
                {
                    title: "Public",
                    name: "aileron/public",
                    type: "folder",
                    roles: ["everyone"],
                    items: [
                        {
                            title: "Workshop",
                            name: "aileron/public/workshops",
                            type: "folder",
                            roles: ["everyone"],
                            items: [
                                {
                                    title: "On-Boarding for a new Workshop",
                                    name: "workshop-onboarding.xlsx",
                                    type: "file",
                                    lastModifiedOn: "2020-02-10 2:15:00pm",
                                    lastModifiedBy: "David Light",
                                    file: "xlsx",
                                    roles: ["everyone"],
                                    size: "3 MB"
                                },
                                {
                                    title: "Generic Workshop Brochure",
                                    name: "generic-workshop-brochure.pdf",
                                    type: "file",
                                    lastModifiedOn: "2020-02-10 2:15:00pm",
                                    lastModifiedBy: "David Light",
                                    file: "pdf",
                                    roles: ["everyone"],
                                    size: "3 MB"
                                }
                            ]
                        },
                        {
                            title: "Aileron Logo",
                            name: "aileron.logo.png",
                            type: "file",
                            lastModifiedOn: "2020-02-10 2:15:00pm",
                            lastModifiedBy: "David Light",
                            file: "png",
                            roles: ["everyone"],
                            size: "3 MB"
                        },
                        {
                            title: "Boilerplate Web Page for Aileron",
                            name: "index.html",
                            type: "file",
                            lastModifiedOn: "2020-02-10 2:15:00pm",
                            lastModifiedBy: "David Light",
                            file: "html",
                            roles: ["everyone"],
                            size: "3 MB"
                        }
                    ]
                }
            ]
        };
        this.selectedItems = [];
        this.breadCrumbs.push(this.rootFolder);
        this.currentFolder = this.rootFolder;
    }
    get itemsPerPage() {
        return 100;
    }
    folderClicked(item) {
        this.breadCrumbs.push(item);
        this.currentFolder = item;
    }
    fileClicked(item) {
        console.log("TODO: File Clicked");
    }
    breadCrumbClicked(props) {
        let tempCrumbs = [];
        let foundNewFolder = false;
        for (let idx = 0; idx < this.breadCrumbs.length; idx++) {
            if (foundNewFolder === false) {
                tempCrumbs.push(this.breadCrumbs[idx]);
            }
            if (this.breadCrumbs[idx].name === props.name) {
                foundNewFolder = true;
                break;
            }
        }
        this.breadCrumbs = tempCrumbs;
        this.currentFolder = props;
    }
    rowSelected(item) {
        this.selectedItems.push(item);
    }
};
FileExporer2View = tslib_1.__decorate([
    Component({
        name: "FileExplorer2View",
        components: {}
    })
], FileExporer2View);
export default FileExporer2View;
